import { Button, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { TradingListItemTypes } from '.';

export const TradingListItemMobile: React.FC<TradingListItemTypes.Content> = ({
  item,
  handleNavigate,
}) => {
  return (
    <VStack
      shadow={0.5}
      height={210}
      borderRadius={Spacing['inset.nano']}
      backgroundColor={Color['neutral.white']}
      paddingX={Spacing['inset.xs']}
      paddingY={Spacing['inset.xs']}
      marginBottom={Spacing['inset.nano']}
      justifyContent={'space-between'}>
      <VStack justifyContent={'space-between'}>
        <Text fontSize={Typography['fontsize.lg']} fontWeight={Typography['fontweight.semibold']}>
          {item.nomeCliente}
        </Text>

        <Text color={['neutral.medium']} fontSize={Typography['fontsize.md']}>
          {item.email}
        </Text>
      </VStack>
      <VStack paddingY={Spacing['inset.xs']} width={'100%'}>
        <HStack paddingBottom={Spacing['inset.quarck']} justifyContent={'space-between'}>
          <Text fontSize={Typography['fontsize.md']} color={'neutral.medium'}>
            Pessoa
          </Text>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Typography['fontsize.md']}>
            {item.tipoPessoaNormalized}
          </Text>
        </HStack>

        <HStack paddingBottom={Spacing['inset.quarck']} justifyContent={'space-between'}>
          <Text paddingBottom={1} fontSize={Typography['fontsize.md']} color={'neutral.medium'}>
            Conta de custódia
          </Text>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Typography['fontsize.md']}>
            {item.contaSuperPNPComDigito}
          </Text>
        </HStack>

        <HStack justifyContent={'space-between'}>
          <Text paddingBottom={1} fontSize={Typography['fontsize.md']} color={'neutral.medium'}>
            Conta BP
          </Text>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Typography['fontsize.md']}>
            {item.contaBPComDigito}
          </Text>
        </HStack>
      </VStack>

      <HStack justifyContent={'space-between'}>
        <VStack flex={1}>
          <Text paddingBottom={1} fontSize={Typography['fontsize.md']} color="neutral.medium">
            Conta sinacor
          </Text>
          <Text
            fontSize={Typography['fontsize.lg']}
            fontWeight={Typography['fontweight.semibold']}
            color="neutral.medium">
            {item.contaSinacorComDigito}
          </Text>
        </VStack>
        <Button
          width={110}
          backgroundColor={Color['brand.tertiary.principal']}
          onPress={() =>
            handleNavigate({
              currentSinacorAccount: item.contaSinacorSemDigito,
              currentAccountPNP: item.contaSuperPNPSemDigito,
              currentIdAccount: item.idConta,
              currentAccountBP: item.contaBPComDigito,
            })
          }>
          DETALHES
        </Button>
      </HStack>
    </VStack>
  );
};
